import React, { useState, useEffect } from 'react';
import { SliderContainer, Slide, HeroContainer, SectionTwoParagraph, HeroHeader, HeroContent, HeroText, SectionOne, SectionTwo, SectionThree, SectionFour, SectionFive, SectionOneHeader, SectionOnePrograms, SectionTwoPicture, SectionTwoContent, SectionTwoHeader, SectionTwoText, SectionThreeVison, SectionThreeVisonHeader, SectionThreeVisonText, SectionThreeWrapper, SectionThreeMission, SectionThreeGoal, SectionThreeMissionText, SectionThreeGoalText, FooterText, ContactWrapper, ContactHeader, SectionTwoPictureTitle, SectionFivecontent, SectionFiveAddress, SectionFiveNumber, SectionFiveMiniHead, SectionFiveMiniContent, ProgramText } from "./HeroStyle";
import slide1 from "../assets/slide1.png";
import slide2 from "../assets/slide2.png";
import slide3 from "../assets/slide3.png";
import slide4 from "../assets/slide4.png";
import slide5 from "../assets/slide5.png";
import founder from "../assets/founder.png";
import Card from "./Card";
import skills from "../assets/skills.png"
import innovate from "../assets/innovate.png"
import mentorship from "../assets/mentorship.png"
import patner from "../assets/patner.png"
import leads from "../assets/leads.png"
import stem from "../assets/stem.png"

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [slide1, slide2, slide3, slide4, slide5];
  const intervalTime = 3000;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % images.length);
    }, intervalTime);

    return () => clearInterval(interval);
  }, [images.length]); // Include images.length in the dependency array

  return (
    <>
    <HeroContainer>
        <HeroContent>
            <HeroHeader>
            Empowering Women For a Brighter Future
            </HeroHeader>
            <HeroText>
            At AAE, we’re passionate about creating positive change in the lives of women through education and empowerment. Our mission is clear: to provide women with the knowledge, skills, and support they need to thrive in all aspects of their lives.
            </HeroText>
        </HeroContent>
    <SliderContainer>
      {images.map((image, index) => (
        <Slide
          key={index}
          src={image}
          alt={`Image ${index + 1}`}
          active={index === currentImageIndex}
        />
      ))}
    </SliderContainer>
    </HeroContainer>

    
    <SectionOne id="section1">
      <SectionOneHeader> Our Programmes</SectionOneHeader>
      <ProgramText> <p>At the AAE Foundation, we offer a range of programs aimed at empowering women and girls through education, mentorship, and leadership development.</p> <p>From scholarships and mentorship initiatives to leadership workshops and skills training programs, our goal is to provide women with the tools and support they need to succeed and thrive in their personal and professional lives. </p>

<p>Join us in our mission to honor the legacy of our inspirational founder and empower women to reach their full potential.</p> 
</ProgramText>
    
      <SectionOnePrograms>
    
        <Card 
            icon={skills}
            title="SkillHer Hub"
            description="Empowering Women with Digital Skills"
            moreInfoTitle="SkillHer Hub
            "
            moreInfoText=
            {
            <>
           <p> At SkillHer Hub, we believe in the power of digital skills to transform lives and open doors to new opportunities. Inspired by the founder's dedication to empowering women and girls, our program is designed to equip participants with the knowledge and skills they need to thrive in today's digital world.</p>
           
           <p> Through hands-on workshops, training sessions, and mentorship opportunities, we empower women to develop confidence and proficiency in digital technologies. Whether it's coding, graphic design, or digital marketing, our goal is to provide women with the tools they need to succeed in the digital economy.</p>
            
          <p>  Join us at SkillHer Hub and unlock your potential for success in the digital age. Together, we can continue the founder's legacy of empowering women and girls to reach new heights of achievement and fulfillment.</p>
          </>}
            
        />
        <Card 
            icon={mentorship}
            title="⁠⁠InnovateHER Fund"
            description="Empowering Women's Innovation"
            moreInfoTitle="SkillHer Hub
            "
            moreInfoText=
            {
            <>
           <p> At SkillHer Hub, we believe in the power of digital skills to transform lives and open doors to new opportunities. Inspired by the founder's dedication to empowering women and girls, our program is designed to equip participants with the knowledge and skills they need to thrive in today's digital world.</p>
           
           <p> Through hands-on workshops, training sessions, and mentorship opportunities, we empower women to develop confidence and proficiency in digital technologies. Whether it's coding, graphic design, or digital marketing, our goal is to provide women with the tools they need to succeed in the digital economy.</p>
            
          <p>  Join us at SkillHer Hub and unlock your potential for success in the digital age. Together, we can continue the founder's legacy of empowering women and girls to reach new heights of achievement and fulfillment.</p>
          </>}
        />
          <Card 

          icon={stem}
            title="STEMinHer Scholarship"
            description="Empowering Women in STEM"
            moreInfoTitle="SkillHer Hub
            "
            moreInfoText=
            {
            <>
           <p> At SkillHer Hub, we believe in the power of digital skills to transform lives and open doors to new opportunities. Inspired by the founder's dedication to empowering women and girls, our program is designed to equip participants with the knowledge and skills they need to thrive in today's digital world.</p>
           
           <p> Through hands-on workshops, training sessions, and mentorship opportunities, we empower women to develop confidence and proficiency in digital technologies. Whether it's coding, graphic design, or digital marketing, our goal is to provide women with the tools they need to succeed in the digital economy.</p>
            
          <p>  Join us at SkillHer Hub and unlock your potential for success in the digital age. Together, we can continue the founder's legacy of empowering women and girls to reach new heights of achievement and fulfillment.</p>
          </>}
        />
      </SectionOnePrograms>

      <SectionOnePrograms>
      <Card 
      icon={innovate}
            title="EmpowerHer Mentorship Program"
            description="Guiding Women to Success"
            moreInfoTitle="SkillHer Hub
            "
            moreInfoText=
            {
            <>
           <p> At SkillHer Hub, we believe in the power of digital skills to transform lives and open doors to new opportunities. Inspired by the founder's dedication to empowering women and girls, our program is designed to equip participants with the knowledge and skills they need to thrive in today's digital world.</p>
           
           <p> Through hands-on workshops, training sessions, and mentorship opportunities, we empower women to develop confidence and proficiency in digital technologies. Whether it's coding, graphic design, or digital marketing, our goal is to provide women with the tools they need to succeed in the digital economy.</p>
            
          <p>  Join us at SkillHer Hub and unlock your potential for success in the digital age. Together, we can continue the founder's legacy of empowering women and girls to reach new heights of achievement and fulfillment.</p>
          </>}
        />
          <Card 
          icon={leads}
            title="LeadHer"
            description="Empowering Women to Lead"
            moreInfoTitle="SkillHer Hub
            "
            moreInfoText=
            {
            <>
           <p> At SkillHer Hub, we believe in the power of digital skills to transform lives and open doors to new opportunities. Inspired by the founder's dedication to empowering women and girls, our program is designed to equip participants with the knowledge and skills they need to thrive in today's digital world.</p>
           
           <p> Through hands-on workshops, training sessions, and mentorship opportunities, we empower women to develop confidence and proficiency in digital technologies. Whether it's coding, graphic design, or digital marketing, our goal is to provide women with the tools they need to succeed in the digital economy.</p>
            
          <p>  Join us at SkillHer Hub and unlock your potential for success in the digital age. Together, we can continue the founder's legacy of empowering women and girls to reach new heights of achievement and fulfillment.</p>
          </>}
        />
          <Card 
          icon={patner}
            title="Education Partnerships"
            description="Collaborating with Institutions for Women's Empowerment"
            moreInfoTitle="SkillHer Hub
            "
            moreInfoText=
            {
            <>
           <p> At SkillHer Hub, we believe in the power of digital skills to transform lives and open doors to new opportunities. Inspired by the founder's dedication to empowering women and girls, our program is designed to equip participants with the knowledge and skills they need to thrive in today's digital world.</p>
           
           <p> Through hands-on workshops, training sessions, and mentorship opportunities, we empower women to develop confidence and proficiency in digital technologies. Whether it's coding, graphic design, or digital marketing, our goal is to provide women with the tools they need to succeed in the digital economy.</p>
            
          <p>  Join us at SkillHer Hub and unlock your potential for success in the digital age. Together, we can continue the founder's legacy of empowering women and girls to reach new heights of achievement and fulfillment.</p>
          </>}
        />

      </SectionOnePrograms>

    </SectionOne>
    <SectionTwo id="section2">

        <SectionTwoPicture><img src={founder} id="founder" alt="founder" />
        <SectionTwoPictureTitle>Late Mrs. Angelica Affiong Etuk</SectionTwoPictureTitle>
        </SectionTwoPicture>

        <SectionTwoContent>
                <SectionTwoHeader> About Us</SectionTwoHeader>
            
                <SectionTwoText> <p><SectionTwoParagraph>Welcome to AAE Foundation, </SectionTwoParagraph> 
                where we celebrate the extraordinary legacy of the inspiration behind the foundation, Late Mrs. Angelica Affiong Etuk, whose indomitable spirit and unwavering dedication to education and empowering continue to inspire us every day. </p>

<p>Late Mrs. Angelica Affiong Etuk was more than just a teacher, she was a beacon of hope, a champion for change, and a force to be reckoned with in the lives of countless women and children. As a devoted educator, she touched the hearts and minds of generations of students, instilling in them the values of knowledge, discipline, compassion and resilience. </p>

<p>Through her tireless efforts, Late Mrs. Angelica Affiong Etuk  helped shape the futures of aspiring lawyers, doctors, accountants and countless other professionals who have gone on to make their mark on the world. Her impact was not only felt in the classroom but also in the lives of those she mentored, supported and inspired to reach for the stars.</p>

<p>At the AAE Foundation, we are honored to carry on Late Mrs. Angelica Affiong Etuk’s legacy of empowerment and transformation through scholarships, mentorship programs and leadership initiatives . The AAE Foundation is empowering the next generation of female leaders and change-makers, carrying forward our Inspirational Founder’s legacy of empowerment and transformation.</p>
<p>As we celebrate the life and work of our mother, we invite you to join us in honoring her legacy and supporting our mission to create a world where every woman and girl has the opportunity to reach her full potential.</p>
                
                
                </SectionTwoText>


        </SectionTwoContent>
    </SectionTwo>
    <SectionThree>
<SectionThreeVison>
<SectionThreeVisonHeader>Our Vision</SectionThreeVisonHeader>
<SectionThreeVisonText>To create a world where women and girls are empowered, educated, and equipped with the skills and resources they need to thrive and lead change in their communities.</SectionThreeVisonText>

</SectionThreeVison>

<SectionThreeWrapper>
    <SectionThreeMission> 

    <SectionThreeVisonHeader>Our Mission</SectionThreeVisonHeader>
    <SectionThreeMissionText><p>At the AAE Foundation, our mission is to champion the advancement of women and girls by providing access to education, fostering mentorship opportunities, and cultivating leadership skills.</p> <p> We are dedicated to honoring the memory of our founder's mother by empowering women to reach their full potential and lead fulfilling lives. </p></SectionThreeMissionText>
    </SectionThreeMission>
    <SectionThreeGoal> 
    <SectionThreeVisonHeader>Our Goal</SectionThreeVisonHeader>
    <SectionThreeGoalText> The goal of the AAE Foundation is to empower women and girls through education, mentorship, and leadership development, ultimately enabling them to reach their full potential and make a positive impact in their communities and beyond.</SectionThreeGoalText>
    </SectionThreeGoal>
</SectionThreeWrapper>

    </SectionThree>
    <SectionFour id="section3">
        <ContactWrapper>

            <ContactHeader>
                Conntact Us
            </ContactHeader>
            <SectionFivecontent>
              <SectionFiveAddress>
                <SectionFiveMiniHead>
                  Address
                </SectionFiveMiniHead>
                  <SectionFiveMiniContent>
               <p>  85, Eket Etinan road,</p> <p>Akwa-Ibom State, Nigeria.</p>
                  </SectionFiveMiniContent>
              </SectionFiveAddress>
            
              <SectionFiveNumber>
              <SectionFiveMiniHead>
                  Phone Number
                </SectionFiveMiniHead> 
                  <SectionFiveMiniContent>
               <p>+234- 803- 304-8469</p>
                  </SectionFiveMiniContent>
              </SectionFiveNumber>

              <SectionFiveNumber>
              <SectionFiveMiniHead>
                  Email
                </SectionFiveMiniHead>
                  <SectionFiveMiniContent>
               <p> contact@aaetukfoundation.org</p>
                  </SectionFiveMiniContent>
              </SectionFiveNumber>
            </SectionFivecontent>
        </ContactWrapper>
    </SectionFour>
    <SectionFive><FooterText>All Information is Copyrighted for AAE Foundation 2024</FooterText></SectionFive>
    
    </>
  );
};

export default Hero;
